import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import theme from '../../../theme';

const textStyling = {
  fontFamily: theme?.components?.batchActionModal?.typography?.text?.fontFamily,
  fontSize: theme?.components?.batchActionModal?.typography?.text?.fontSize,
  lineHeight: theme?.components?.batchActionModal?.typography?.text?.lineHeight,
  mt: 1,
};

const ProgressBar = ({ isComplete, failedCount, updatedCount, totalCount }) => {
  const processedCount = updatedCount + failedCount;
  const calcdProgressPercent = totalCount > 0 ? Math.round((processedCount / totalCount) * 100) : 0;

  const progressPercent = isComplete ? 100 : calcdProgressPercent;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography sx={textStyling}>
        {isComplete
          ? LanguageConverterV2('progress.completed')
          : LanguageConverterV2('progress.processing')}
        ({progressPercent <= 100 ? progressPercent : 100}%)
      </Typography>
      <progress value={progressPercent} max="100" style={{ width: '100%' }} />

      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
        <Typography>{LanguageConverterV2('progress.updated')}</Typography>
        <Typography>{updatedCount}</Typography>
      </Box>
      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
        <Typography>{LanguageConverterV2('progress.failed')}</Typography>
        <Typography>{failedCount}</Typography>
      </Box>
    </Box>
  );
};

ProgressBar.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  failedCount: PropTypes.number.isRequired,
  updatedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};

ProgressBar.defaultProps = {};

export default ProgressBar;
